export const propertyPageGallery = ['$scope', function ($scope) {
    $scope.activeView = 1;
}]

